export default [
    'http://i.imgur.com/Udz7RRD.jpg',
    'http://i.imgur.com/OG4Filt.jpg',
    'http://i.imgur.com/Dm3yaqR.jpg',
    'http://i.imgur.com/qkUnoDt.jpg'
];